<script>
  import { GQLNow } from "gql-now";
  import { onMount } from "svelte";
  import { PKClient } from "../services/PKClient";
  import { CSVDownloader } from "svelte-csv";
  import moment from "moment";
  import {
    App,
    f7,
    f7ready,
    Card,
    CardFooter,
    CardContent,
    CardHeader,
    Page,
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Toolbar,
    Block,
    BlockTitle,
    List,
    ListItem,
    Row,
    Col,
    Button,
    Gauge,
    AreaChart,
    Panel,
    Menu,
    MenuItem,
    MenuDropdown,
    MenuDropdownItem,
    Icon,
    Searchbar,
    AccordionContent,
  } from "framework7-svelte";
  export let f7route;
  export let f7router;

  let admin_access_token, pan_name, ifsc, account_no, session;

  onMount(() => {
    f7ready(async () => {
      admin_access_token = localStorage.getItem("token");
    });
  });

  async function verify_penny_drop() {
    console.log(account_no, pan_name, ifsc);
    // console.log("user inputs:", withdraw_status, processed_amount);
    let obj = new GQLNow(`https://api.trdr.money/graphql/trdr-admin-services`, {
      "x-trdr-org": "60e6cd9df9c32f00072b71f8",
      "x-access-token": admin_access_token,
    });
    try {
      f7.preloader.show();
      let response = await obj.query(
        "verify_penny_drop",
        {
          account_no,
          ifsc,
          pan_name,
        },
        "penny_drop_status name_from_pd name_from_pan name_match_score"
      );
      session = response.data.verify_penny_drop;
      console.log("verify_penny_drop API Response", session);
      f7.preloader.hide();
      return session;
      // f7router.navigate(`/thankyou/`);
    } catch (err) {
      f7.preloader.hide();
      // f7router.navigate(`/admin-login-otp/`);
      console.log("Error happened in penny drop verify api | Admin");
      throw err;
    }
  }
</script>

<Page class="admin-home">
  <Panel left cover id="panel-left" />

  <!-- Top Navbar -->
  <Navbar
    large
    style="--f7-navbar-bg-color: white;
    --f7-navbar-text-color: black;
    --f7-navbar-link-color: black;"
    sliding={false}
  >
    <NavLeft>
      <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen="#panel-left"
      />
      <Link
        searchbarEnable=".searchbar-demo"
        iconIos="f7:search"
        iconAurora="f7:search"
        iconMd="material:search"
      />
    </NavLeft>
    <!-- <NavTitle>Admin Dashboard</NavTitle> -->

    <NavRight>
      <Link>
        <p class="title-text">URL:desk.trdr.money</p>
      </Link>
      <Link
        iconIos="f7:bell_fill"
        iconAurora="f7:bell_fill"
        iconMd="f7:bell_fill"
      />
      <Link
        iconIos="f7:question_circle"
        iconAurora="f7:question_circle"
        iconMd="f7:question_circle"
      />
      <Link
        iconIos="f7:person_alt_circle"
        iconAurora="f7:person_alt_circle"
        iconMd="f7:person_alt_circle"
      />
    </NavRight>

    <NavTitleLarge>Admin Dashboard</NavTitleLarge>

    <Searchbar
      class="searchbar-demo"
      expandable
      searchContainer=".search-list"
      searchIn=".item-title"
      disableButton
      disableButtonText
      clearButton
    />
  </Navbar>
  <!-- Toolbar 
  <Toolbar bottom>
    <Link>Left Link</Link>
    <Link>Right Link</Link>
  </Toolbar> -->
  <!-- Page content 
  <Block strong>
    <p>Here is your blank Framework7 app. Let's see what we have here.</p>
  </Block> -->

  <div class="page-content padding">
    <BlockTitle large class="padding-left padding-top"
      >Verify Penny drop</BlockTitle
    >
    <Block>
      <div class="card data-table hoverTable">
        <div style="padding:15px" />
        <form on:submit|preventDefault={verify_penny_drop}>
          <input
            type="text"
            bind:value={account_no}
            id="acc_no"
            name="acc_no"
            placeholder="account number"
            style="border-radius: 5px;
                  background-color: #f2f2f2;
                  padding: 10px;
                  width:70%;
                  color:black"
          /> <br />
          <input
            type="text"
            bind:value={ifsc}
            id="ifsc"
            name="ifsc"
            placeholder="ifsc"
            style="border-radius: 5px;
                background-color: #f2f2f2;
                padding: 10px;
                width:70%;
                color:black"
          />
          <br />
          <input
            type="text"
            bind:value={pan_name}
            id="pan_name"
            name="pan_name"
            placeholder="pan name"
            style="border-radius: 5px;
              background-color: #f2f2f2;
              padding: 10px;
              width:70%;
              color:black"
          /> <br />
          <button
            style="border-radius: 5px;
          background-color: #000000;
          padding: 10px;
          width:70%;
          color:white"
            type="submit"
          >
            Verify
          </button>

          <br /><br />
        </form>
      </div>
    </Block>

    {#if session}
      <Block>
        <div class="card data-table hoverTable">
          Penny drop status: {session.penny_drop_status} <br />
          Bank Name:{session.name_from_pd} <br />
          Pan Name: {session.name_from_pan}<br />
          Name match score:{session.name_match_score} <br />
        </div>
      </Block>
    {/if}
  </div>
</Page>

<style>
  :global(.demo-card-header-pic .card-header) {
    height: 40vw;
    background-size: cover;
    background-position: center;
    color: #fff;
  }
  :global(.demo-card-header-pic .card-content-padding .date) {
    color: #8e8e93;
  }
  :global(.title-text) {
    position: relative;
    overflow: hidden;
    margin: 0;
    white-space: var(--f7-block-title-white-space);
    text-overflow: ellipsis;
    text-transform: var(--f7-block-title-text-transform);
    color: var(--f7-block-title-text-color);
    font-size: var(--f7-block-title-font-size, inherit);
    font-weight: var(--f7-block-title-font-weight);
    line-height: var(--f7-block-title-line-height);
  }
  .hoverTable {
    width: 100%;
    border-collapse: collapse;
  }
  .hoverTable th {
    background-color: #000;
    color: #fff;
  }
  .hoverTable tr:hover {
    background-color: #000;
    color: #fff;
  }
</style>
